export default "/ca87e20b85d3d6d44e0f67c0422e9274.svg";